import { InputAdornment, TextField } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { get } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { setPage } from '../../../store/features/moments/momentsSlice';

const SpecialMoments = () => {
    const dispatch = useDispatch();
    const [accordionDetailsList, setAccordionDetailsList] = useState<any>([]);
    const [expanded, setExpanded] = React.useState<string | false>('');
    const [searchParam, setSearchParam] = useState('');
    const [specialMomentData, setSpecialMomentData] = useState<any>([]);
    const { words } = useAppSelector(state => state.localization);

    useEffect(() => {
        const getSpecialDate = async () => {
            const response = await get<any>(`/specialdate/get-special-date-list`);
            setSpecialMomentData(response.result.items);
        };
        getSpecialDate();
    }, [words]);

    useEffect(() => {
        setExpanded(false);
    }, [words]);

    const handleChange = (specialDateId: string) => async (event, newExpanded: boolean) => {
        const response = await get<any>(`specialdate/get-special-date-list-by-id?id=${specialDateId}`);
        const item = response.result;
        setAccordionDetailsList([item]);
        setExpanded(newExpanded ? specialDateId : false);
    };

    const filterSpecialMoments = async () => {
        const response = await get<any>(`/specialdate/get-special-date-list?Search=${searchParam}`);
        setSpecialMomentData(response.result.items);
    };

    const filterSpicealMomemntsOnKeyUp = async e => {
        const response = await get<any>(`/specialdate/get-special-date-list?Search=${searchParam}`);
        if (e.key === 'Enter') {
            setSpecialMomentData(response.result.items);
        }
    };

    const clearInputValue = () => {
        setSearchParam('');
        const getSpecialDate = async () => {
            const response = await get<any>(`/specialdate/get-special-date-list`);

            setSpecialMomentData(response.result.items);
        };
        getSpecialDate();
    };

    return (
        <div className="special-moments">
            <div className="micro-content-01">
                <a className="c-item-01" href="#!" onClick={() => dispatch(setPage({ name: 'momentsHome', type: '', id: '' }))}>
                    <svg className="close-icon" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                            stroke="#6C6C7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M21.875 13.125L13.125 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.125 13.125L21.875 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </a>

                <h2 className="c-item-02">{words && words['WEB.specialMomentContents']}</h2>
                <p className="c-item-03">{words && words['WEB.specialMomentTextForTeams']}</p>
            </div>

            <div className="micro-content-02">
                <TextField
                    onKeyUp={filterSpicealMomemntsOnKeyUp}
                    className="c-item-01"
                    id="input-with-icon-textfield"
                    placeholder={words && words['WEB.searchSpecialMoment']}
                    variant="standard"
                    value={searchParam}
                    onChange={e => setSearchParam(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <svg
                                    className="c-item-01-A"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M21.0004 20.9999L16.6504 16.6499"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="start">
                                {searchParam && (
                                    <svg
                                        onClick={clearInputValue}
                                        className="c-item-01-B"
                                        width="35"
                                        height="35"
                                        viewBox="0 0 35 35"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17.4998 32.0832C25.554 32.0832 32.0832 25.554 32.0832 17.4998C32.0832 9.44568 25.554 2.9165 17.4998 2.9165C9.44568 2.9165 2.9165 9.44568 2.9165 17.4998C2.9165 25.554 9.44568 32.0832 17.4998 32.0832Z"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M21.875 13.125L13.125 21.875"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M13.125 13.125L21.875 21.875"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />

                <a href="#!" onClick={filterSpecialMoments} className="c-item-02">
                    <p className="c-item-02-A">{words && words['WEB.search']}</p>
                </a>
            </div>

            {specialMomentData.length === 0 && <div className="not-founded">{words && words['WEB.resultNotFounded']}</div>}

            {specialMomentData.length > 0 &&
                specialMomentData.map(item => {
                    return (
                        <div key={'special-date-accordion' + item.id} className={expanded === item.id ? 'section-08 active ' : 'section-08'}>
                            <Accordion expanded={expanded === item.id} className="accordion-header" onChange={handleChange(`${item.id}`)}>
                                <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
                                    <div className={expanded === item.id ? 'c-item-01 active ' : 'c-item-01'}>
                                        <img className="c-item-01-A" src={expanded === item.id ? item.imageURLSecond : item.imageURL} />
                                        <span className="c-item-01-B">{item.name}</span>
                                    </div>
                                    <div className="c-item-02">
                                        <a href="#!" className="c-item-02-A">
                                            {expanded === item.id ? (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6 9L12 15L18 9"
                                                        stroke="white"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            ) : (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9 18L15 12L9 6"
                                                        stroke="#7E7E92"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            )}
                                        </a>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className="accordion-details">
                                    {accordionDetailsList.length > 0 && (
                                        <>
                                            {accordionDetailsList.some(x => x.id === item.id) && (
                                                <p className="c-item-01">
                                                    {accordionDetailsList.find(x => x.id === item.id)?.actionGroup?.description}
                                                </p>
                                            )}

                                            <div className="c-item-02">
                                                <div className="c-item-02-A">
                                                    <div className="c-unit-01">
                                                        <svg
                                                            className="c-unit-01-A"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M10.0003 18.3332C14.6027 18.3332 18.3337 14.6022 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 14.6022 5.39795 18.3332 10.0003 18.3332Z"
                                                                stroke="#F42E36"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.5752 7.49999C7.77112 6.94304 8.15782 6.47341 8.66682 6.17426C9.17583 5.87512 9.77427 5.76577 10.3562 5.86558C10.9381 5.96539 11.4659 6.26792 11.8461 6.71959C12.2263 7.17126 12.4344 7.74292 12.4335 8.33332C12.4335 9.99999 9.93353 10.8333 9.93353 10.8333"
                                                                stroke="#F42E36"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M10 14.1665H10.0083"
                                                                stroke="#F42E36"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>

                                                        <span className="c-unit-01-B">{words && words['WEB.whatCanWeDone']}</span>
                                                    </div>
                                                    {accordionDetailsList.length > 0 &&
                                                        accordionDetailsList
                                                            .find(x => x.id === item.id)
                                                            ?.actionFlows?.map(actionflowItem => (
                                                                <p className="c-unit-02" key={'flowItem-' + actionflowItem?.id}>
                                                                    - {actionflowItem?.description}
                                                                </p>
                                                            ))}
                                                </div>
                                                <div className="c-item-02-B">
                                                    <div className="c-unit-01">
                                                        <svg
                                                            className="c-unit-01-A"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
                                                                stroke="#F42E36"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>

                                                        <span className="c-unit-01-B">{words && words['WEB.oneOfUs']}</span>
                                                    </div>
                                                    {accordionDetailsList.length > 0 &&
                                                        accordionDetailsList
                                                            .find(x => x.id === item.id)
                                                            ?.testimonials?.map(testimonial => (
                                                                <p className="c-unit-02" key={'testimonial' + testimonial?.id}>
                                                                    {' '}
                                                                    “{testimonial?.description}“
                                                                </p>
                                                            ))}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    );
                })}
        </div>
    );
};

export default SpecialMoments;
